module.exports = __webpack_public_path__ + "static/Anaplan-75dd05910b5b0cff138af9638d6b9706.jpg";